<template>
  <div class="article-list">
    <!-- 查询控件卡片 -->
    <el-card class="filter-card">
      <div class="filter-container">
        <!-- 左侧查询表单 -->
        <div class="left-section">
          <el-form :inline="true" :model="queryParams" class="filter-form" size="small">
            <div class="form-content">
              <el-form-item>
                <el-input
                  v-model="queryParams.keyword"
                  placeholder="关键词"
                  clearable
                  @keyup.enter.native="handleQuery"
                  style="width: 180px"
                />
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="queryParams.article_name"
                  placeholder="文章名称"
                  clearable
                  @keyup.enter.native="handleQuery"
                  style="width: 180px"
                />
              </el-form-item>
              <el-form-item>
                <el-select v-model="queryParams.article_type" placeholder="文章类型" clearable style="width: 120px">
                  <el-option
                    v-for="item in articleTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="queryParams.article_tag"
                  placeholder="标签"
                  clearable
                  style="width: 180px"
                />
              </el-form-item>
              <el-form-item class="filter-buttons">
                <el-button @click="handleReset">重置</el-button>
                <el-button type="primary" @click="handleQuery">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <!-- 右侧数据展示 -->
        <div class="right-section">
          <!-- 文章数 -->
          <div class="stat-card">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">文章数</div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 数据表格卡片 -->
    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="articleList"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#f2f3f5',
          color: '#606266',
          fontWeight: '600',
          fontSize: '14px',
          height: '52px',
          padding: '0'
        }"
        @sort-change="handleSortChange">
        
        <!-- 序号列 -->
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center">
        </el-table-column>
        
        <el-table-column 
          prop="article_name" 
          label="文章名称" 
          min-width="200"
          sortable="custom">
          <template slot-scope="scope">
            <span class="article-name" @click="handleView(scope.row)">
              <span v-if="scope.row.is_top" class="top-pill" aria-label="置顶">置顶</span>
              <span class="name-text">{{ scope.row.article_name }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column 
          prop="article_type" 
          label="类型" 
          width="100"
          sortable="custom">
          <template slot-scope="scope">
            <el-tag
              :color="getArticleTypeStyle(scope.row.article_type)"
              effect="dark"
              class="article-type-tag"
              size="mini"
              style="height: 28px; line-height: 26px; width: 46px; text-align: center;"
            >{{ scope.row.article_type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="article_tag" label="标签" width="250">
          <template slot-scope="scope">
            <div v-if="scope.row.article_tag" class="tag-list">
              <el-tag
                v-for="tag in scope.row.article_tag.split(',')"
                :key="tag"
                size="mini"
                class="article-tag"
                style="height: 24px; line-height: 22px;">
                {{ tag }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column 
          prop="create_time" 
          label="创建时间" 
          width="180" 
          sortable="custom" />
        <el-table-column label="操作" width="360" align="center">
          <template slot-scope="scope">
            <div class="operation-buttons">
              <el-button
                size="mini"
                type="primary"
                style="height: 28px; line-height: 26px; margin: 0; text-align: center; display: flex; align-items: center; justify-content: center;"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <el-button
                size="mini"
                :type="scope.row.is_push ? 'warning' : 'success'"
                style="height: 28px; line-height: 26px; margin: 0; text-align: center; display: flex; align-items: center; justify-content: center;"
                @click="handleTogglePush(scope.row)"
              >{{ scope.row.is_push ? '隐藏' : '发布' }}</el-button>
              <el-button
                size="mini"
                :type="scope.row.is_top ? 'purple' : 'info'"
                :class="{'purple-button': scope.row.is_top}"
                style="height: 28px; line-height: 26px; margin: 0; text-align: center; display: flex; align-items: center; justify-content: center;"
                @click="handleToggleTop(scope.row)"
              >{{ scope.row.is_top ? '取消置顶' : '置顶' }}</el-button>
              <el-button
                size="mini"
                :class="scope.row.has_password ? 'password-btn-filled' : 'password-btn-outline'"
                style="height: 28px; line-height: 26px; margin: 0; text-align: center; display: flex; align-items: center; justify-content: center;"
                @click="handlePassword(scope.row)"
              >{{ scope.row.has_password ? '查看密码' : '加密' }}</el-button>
              <el-button
                size="mini"
                type="danger"
                style="height: 28px; line-height: 26px; margin: 0; text-align: center; display: flex; align-items: center; justify-content: center;"
                @click="handleDelete(scope.row)"
              >删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        background
        :current-page.sync="queryParams.page"
        :page-sizes="[20, 50, 100]"
        :page-size="queryParams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    </el-card>

    <!-- 版权信息卡片 -->
    <el-card class="copyright-card">
      <div class="copyright-content">
        <span>Copyright © 2024 OIer之路 All rights reserved.  |  闽ICP备2025095302号-1</span>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getArticles, deleteArticle, updateArticlePushStatus, updateArticleTopStatus, setArticlePassword, removeArticlePassword, getArticle } from '@/api/article'

export default {
  name: 'ArticleList',
  data() {
    return {
      // 文章类型选项
      articleTypes: [
        { value: 'OI', label: 'OI' },
        { value: '题解', label: '题解' },
        { value: '游记', label: '游记' },
        { value: '生活', label: '生活' },
        { value: '学习', label: '学习' },
        { value: '科技', label: '科技' },
        { value: '情感', label: '情感' },
        { value: '游戏', label: '游戏' },
        { value: '随笔', label: '随笔' },
        { value: '其他', label: '其他' }
      ],
      // 查询参数
      queryParams: {
        page: 1,
        size: 20,
        keyword: '',
        article_name: '',
        article_type: '',
        article_tag: '',
        sort_prop: 'create_time',  // 默认按创建时间排序
        sort_order: 'descending'   // 默认降序
      },
      loading: false,
      total: 0,
      articleList: [],
      currentPage: 1,
      pageSize: 20,
      // 密码查看弹窗
      pwdDialogVisible: false,
      pwdDialogRow: null,
      pwdDialogHash: '',
      pwdPwdShowing: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    shouldApplyPinnedSort() {
      return this.queryParams.sort_prop === 'create_time' &&
        (this.queryParams.sort_order === 'descending' || !this.queryParams.sort_order)
    },
    parseTimeToTs(timeStr) {
      if (!timeStr) return 0
      const ts = new Date(String(timeStr).replace(/-/g, '/')).getTime()
      return Number.isFinite(ts) ? ts : 0
    },
    sortPinnedFirstByCreateTimeDesc(list) {
      // 仅用于“默认排序：创建时间倒序”时的前端二级排序：置顶优先
      return [...(list || [])].sort((a, b) => {
        const aTop = a?.is_top ? 1 : 0
        const bTop = b?.is_top ? 1 : 0
        if (aTop !== bTop) return bTop - aTop
        return this.parseTimeToTs(b?.create_time) - this.parseTimeToTs(a?.create_time)
      })
    },
    // 获取文章类型对应的样式
    getArticleTypeStyle(type) {
      const styleMap = {
        'OI': '#409EFF',        // Element UI 主蓝色
        '题解': '#67C23A',      // Element UI 成功绿色
        '游记': '#E6A23C',      // Element UI 警告黄色
        '生活': '#F56C6C',      // Element UI 危险红色
        '学习': '#8E44AD',      // 深紫色
        '科技': '#16A085',      // 深青色
        '情感': '#D35400',      // 深橙色
        '游戏': '#2980B9',      // 深蓝色
        '随笔': '#27AE60',      // 深绿色
        '其他': '#C0392B'       // 深红色
      }
      return styleMap[type] || ''
    },
    // 获取文章列表
    async getList() {
      this.loading = true
      try {
        const response = await getArticles(this.queryParams)
        const items = response?.data?.items || []
        this.articleList = this.shouldApplyPinnedSort()
          ? this.sortPinnedFirstByCreateTimeDesc(items)
          : items
        this.total = response.data.total
      } catch (error) {
        console.error('获取文章列表失败：', error)
        this.$message.error('获取文章列表失败')
      }
      this.loading = false
    },
    // 查询按钮点击
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    // 重置按钮点击
    handleReset() {
      this.queryParams = {
        page: 1,
        size: 20,
        keyword: '',
        article_name: '',
        article_type: '',
        article_tag: '',
        sort_prop: 'create_time',
        sort_order: 'descending'
      }
      this.getList()
    },
    // 新增按钮点击
    handleAdd() {
      this.$router.push('/article/edit')
    },
    // 查看按钮点击
    handleView(row) {
      this.$router.push(`/article/view/${row.article_code}`)
    },
    // 编辑按钮点击
    handleEdit(row) {
      this.$router.push(`/article/edit/${row.article_code}`)
    },
    // 删除按钮点击
    handleDelete(row) {
      this.$confirm('确认要删除这篇文章吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteArticle(row.article_code)
          this.$message.success('删除成功')
          this.getList()
        } catch (error) {
          console.error('删除文章失败：', error)
          this.$message.error('删除文章失败')
        }
      }).catch(() => {})
    },
    // 切换发布/隐藏状态
    async handleTogglePush(row) {
      const action = row.is_push ? '隐藏' : '发布';
      try {
        await updateArticlePushStatus(row.article_code, !row.is_push);
        this.$message.success(`${action}成功`);
        // 更新本地数据状态
        if (!row.hasOwnProperty('is_push')) {
          this.$set(row, 'is_push', 0); // 如果属性不存在，先初始化为0
        }
        row.is_push = !row.is_push;
      } catch (error) {
        console.error(`${action}文章失败：`, error);
        this.$message.error(`${action}文章失败`);
      }
    },
    // 切换置顶/取消置顶状态
    async handleToggleTop(row) {
      const action = row.is_top ? '取消置顶' : '置顶';
      try {
        await updateArticleTopStatus(row.article_code, !row.is_top);
        this.$message.success(`${action}成功`);
        // 更新本地数据状态
        if (!row.hasOwnProperty('is_top')) {
          this.$set(row, 'is_top', 0); // 如果属性不存在，先初始化为0
        }
        row.is_top = !row.is_top;
        if (this.shouldApplyPinnedSort()) {
          this.articleList = this.sortPinnedFirstByCreateTimeDesc(this.articleList)
        }
      } catch (error) {
        console.error(`${action}文章失败：`, error);
        this.$message.error(`${action}文章失败`);
      }
    },
    // 密码管理按钮点击
    handlePassword(row) {
      if (row.has_password) {
        // 有密码，显示查看密码弹窗
        this.showPasswordDialog(row)
      } else {
        // 无密码，显示设置密码弹窗
        this.showSetPasswordDialog(row)
      }
    },
    // 显示设置密码弹窗
    showSetPasswordDialog(row) {
      this.$prompt('请输入文章密码', '设置文章密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        inputValidator: (value) => {
          if (!value) return '密码不能为空'
          return true
        }
      }).then(async ({ value }) => {
        // 确认密码
        this.$prompt('请再次输入密码', '确认密码', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputValidator: (val) => {
            if (!val) return '请再次输入密码'
            if (val !== value) return '两次输入密码不一致'
            return true
          }
        }).then(async ({ value: confirmValue }) => {
          try {
            await setArticlePassword(row.article_code, confirmValue)
            this.$message.success('密码设置成功')
            this.getList()
          } catch (error) {
            console.error('设置密码失败：', error)
            this.$message.error('设置密码失败')
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    // 复制密码
    copyPwdHash() {
      if (!this.pwdDialogHash) return
      this.copyToClipboard(this.pwdDialogHash)
    },
    // 通用复制方法
    copyToClipboard(text) {
      const div = document.createElement('div')
      div.textContent = text
      div.style.position = 'fixed'
      div.style.left = '-9999px'
      div.style.top = '-9999px'
      document.body.appendChild(div)

      const range = document.createRange()
      range.selectNodeContents(div)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)

      document.execCommand('copy')
      selection.removeAllRanges()
      document.body.removeChild(div)
      this.$message.success('密码已复制')
    },
    // 显示查看密码弹窗（使用 ElMessageBox，和 $prompt 同一组件）
    async showPasswordDialog(row) {
      try {
        const response = await getArticle(row.article_code)
        const article = response.data
        this.pwdDialogRow = row
        this.pwdDialogHash = article.article_password || ''

        const h = this.$createElement

        // 密码行
        const pwdRow = h('div', { class: 'pwd-row' }, [
          h('span', { class: 'pwd-label' }, '密码：'),
          h('span', {
            class: 'pwd-value',
            style: 'font-size:14px;font-family:monospace;letter-spacing:1px;color:#303133;flex:1;overflow:hidden;text-overflow:ellipsis;',
            domProps: { id: 'pwd-text' }
          }, '••••••••••••••••'),
          h('i', {
            class: 'el-icon-view pwd-icon-btn',
            style: 'cursor:pointer;font-size:16px;color:#909399;',
            attrs: { id: 'pwd-toggle' },
            on: {
              click: () => {
                const textEl = document.getElementById('pwd-text')
                const iconEl = document.getElementById('pwd-toggle')
                if (!textEl || !iconEl) return
                const isShowing = textEl.textContent !== '••••••••••••••••'
                if (isShowing) {
                  textEl.textContent = '••••••••••••••••'
                  iconEl.style.color = '#909399'
                } else {
                  textEl.textContent = this.pwdDialogHash
                  iconEl.style.color = '#16988C'
                }
              }
            }
          }),
          h('i', {
            class: 'el-icon-document-copy pwd-icon-btn',
            style: 'cursor:pointer;font-size:16px;color:#909399;margin-left:6px;',
            on: { click: () => {
              if (!this.pwdDialogHash) return
              this.copyToClipboard(this.pwdDialogHash)
            }}
          })
        ])

        // 按钮行（真实 el-button 组件）
        const btnRow = h('div', { class: 'pwd-btn-row' }, [
          h('el-button', {
            props: { type: 'primary', size: 'small' },
            on: {
              click: () => {
                this.$msgbox.close()
                this.showChangePasswordDialog()
              }
            }
          }, '修改密码'),
          h('el-button', {
            props: { type: 'danger', size: 'small', plain: true },
            on: {
              click: () => {
                this.$msgbox.close()
                this.showRemovePasswordDialog()
              }
            }
          }, '取消密码')
        ])

        this.$msgbox({
          title: '文章密码',
          message: h('div', { class: 'pwd-msgbox-content' }, [pwdRow, btnRow]),
          confirmButtonText: '关闭',
          cancelButtonText: '取消',
          closeOnClickModal: false
        }).then(() => {}).catch(() => {})
      } catch (error) {
        console.error('获取文章信息失败：', error)
        this.$message.error('获取文章信息失败')
      }
    },
    // 修改密码流程
    showChangePasswordDialog() {
      this.$prompt('请输入原密码', '验证原密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        closeOnClickModal: false
      }).then(async ({ value }) => {
        this.$prompt('请输入新密码', '设置新密码', {
          confirmButtonText: '下一步',
          cancelButtonText: '取消',
          inputType: 'password',
          closeOnClickModal: false
        }).then(async ({ value: newPassword }) => {
          this.$prompt('请再次输入新密码', '确认新密码', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            closeOnClickModal: false,
            inputValidator: (val) => {
              if (!val) return '请再次输入新密码'
              if (val !== newPassword) return '两次输入密码不一致'
              return true
            }
          }).then(async ({ value: confirmPassword }) => {
            try {
              await setArticlePassword(this.pwdDialogRow.article_code, confirmPassword)
              this.$message.success('密码修改成功')
              this.getList()
            } catch (error) {
              console.error('修改密码失败：', error)
              this.$message.error('修改密码失败')
            }
          }).catch(() => {})
        }).catch(() => {})
      }).catch(() => {})
    },
    // 取消密码流程
    showRemovePasswordDialog() {
      this.$prompt('请输入原密码以确认取消密码保护', '取消密码保护', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
        closeOnClickModal: false
      }).then(async ({ value }) => {
        try {
          await removeArticlePassword(this.pwdDialogRow.article_code, value)
          this.$message.success('密码已取消')
          this.getList()
        } catch (error) {
          console.error('取消密码失败：', error)
          if (error.response?.data?.message === '密码错误') {
            this.$message.error('密码错误')
          } else {
            this.$message.error('取消密码失败')
          }
        }
      }).catch(() => {})
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.queryParams.size = val
      this.getList()
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getList()
    },
    // 处理排序变化
    handleSortChange({ prop, order }) {
      this.queryParams.sort_prop = prop
      this.queryParams.sort_order = order
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.article-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  background-color: #f0f2f5;
  overflow: hidden; /* 添加overflow:hidden防止整体出现滚动条 */

  .filter-card {
    margin: 8px 0 0 0;
    flex-shrink: 0;
    background-color: #fff;
    position: relative;
    z-index: 10;
    height: 72px;

    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
    }
  }

  .filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 16px;

    .left-section {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-right: 20px;
      flex-shrink: 1;
      overflow-x: auto;
      height: 100%;

      .filter-form {
        display: flex;
        align-items: center;
        white-space: nowrap;
        height: 100%;

        .form-content {
          display: flex;
          align-items: center;
          gap: 8px;
          height: 100%;

          :deep(.el-input),
          :deep(.el-select) {
            .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          :deep(.el-button) {
            height: 32px;
            line-height: 30px;
            padding: 0 16px;
          }

          .el-form-item {
            margin-bottom: 0;
            margin-right: 0;
          }
        }
      }
    }

    .right-section {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
      padding: 0 12px;
      background-color: #f6f8fa;
      border-radius: 8px;
      height: 52px;

      .stat-card {
        text-align: center;
        min-width: 60px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        padding: 0 10px;

        .stat-value {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          line-height: 1;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 12px;
          color: #6b7280;
          line-height: 1;
        }
      }
    }
  }

  .table-card {
    margin: 8px 0 0 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
    min-height: 0;
    
    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    
    :deep(.el-table) {
      flex: 1;
      height: 100%;
      
      .el-table__header-wrapper {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: #f5f7fa;

        th {
          background-color: #f5f7fa;
          color: #606266;
          font-weight: 600;
          font-size: 14px;
          height: 52px;
          padding: 0;
          border-bottom: 1px solid #ebeef5;
        }
      }
      
      .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 60px);
      }

      // 表格行高度
      .el-table__row {
        height: 52px;
      }

      // 表格单元格内边距
      td {
        padding: 8px 0;
        border-bottom: 1px solid #ebeef5;
      }
    }

    .article-name {
      color: #409eff;
      cursor: pointer;
      font-size: 13px;
      display: flex;
      align-items: center;
      gap: 8px;
      
      &:hover {
        text-decoration: underline;
      }
      
      .top-pill {
        height: 20px;
        line-height: 20px;
        padding: 0 8px;
        border-radius: 4px;
        background: transparent;
        color: #1f6feb;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.3px;
        border: 1px solid #1f6feb;
        white-space: nowrap;
        pointer-events: none;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        gap: 4px;
      }
      .top-pill .top-emoji { color: #1f6feb; font-size: 14px; }

      .name-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    
    .article-type-tag {
      height: 24px;
      line-height: 24px;
      padding: 0 8px;
      font-size: 12px;
      border: none;
    }
    
    .tag-list {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      overflow: hidden;
      max-width: 100%;
      position: relative;
      height: 32px;
      
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 30px;
        background: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1));
        pointer-events: none;
      }
    }
    
    .article-tag {
      margin-right: 4px;
      height: 22px;
      line-height: 20px;
      font-size: 11px;
      
      &:last-child {
        margin-right: 0;
      }
    }
    
    .operation-buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }
    
    :deep(.el-button.el-button--mini) {
      padding: 5px 10px;
    }

    // 添加紫色按钮样式
    :deep(.purple-button) {
      background-color: #8E44AD;
      border-color: #8E44AD;
      color: white;
      
      &:hover, &:focus {
        background-color: #9B59B6;
        border-color: #9B59B6;
        color: white;
      }
      
      &:active {
        background-color: #7D3C98;
        border-color: #7D3C98;
        color: white;
      }
    }

    // 密码按钮样式（teal色，独立于其他按钮）
    // 有密码 - 查看密码（深色 solid）
    :deep(.password-btn-filled) {
      background-color: #16988C;
      border-color: #16988C;
      color: white;

      &:hover, &:focus {
        background-color: #1aad9e;
        border-color: #1aad9e;
        color: white;
      }

      &:active {
        background-color: #12807a;
        border-color: #12807a;
        color: white;
      }
    }

    // 无密码 - 加密（浅色 solid，和深色形成对比）
    :deep(.password-btn-outline) {
      background-color: #5dc9bf;
      border-color: #5dc9bf;
      color: white;

      &:hover, &:focus {
        background-color: #79d5cb;
        border-color: #79d5cb;
        color: white;
      }

      &:active {
        background-color: #4bb8af;
        border-color: #4bb8af;
        color: white;
      }
    }

    // 分页容器移到卡片内，调整样式
  .pagination-container {
    height: 40px;
    padding: 0 16px;
    background-color: #fff;
    border-top: 1px solid #e4e7ed;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
    z-index: 1;
    }
  }

  .copyright-card {
    margin: 8px 0;
    flex-shrink: 0;
    background-color: #fff;
    border-radius: 4px;
    height: 40px;
    position: relative;
    z-index: 1;

    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
    }

    .copyright-content {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      font-size: 14px;
      
      span {
        line-height: 1;
      }
    }
  }
}
</style>
<style lang="scss">
// $msgbox 内部内容的样式（非 scoped，穿透到 ElMessageBox 内部）
.pwd-msgbox-content {
  padding: 5px 0;
  .pwd-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;
    padding-top: 5px;
  }
  .pwd-label {
    font-size: 13px;
    color: #606266;
    flex-shrink: 0;
  }
  .pwd-icon-btn {
    cursor: pointer;
    font-size: 16px;
    transition: color 0.2s;
    color: #909399;
    &:hover {
      color: #16988C !important;
    }
  }
  .pwd-btn-row {
    display: flex;
    gap: 10px;
    padding-top: 15px;
    border-top: 1px solid #ebeef5;
  }
}
</style> 